import React from 'react';
import LegalDocumentPage from './LegalDocumentPage.jsx';

export default function TermsOfService() {
  return <LegalDocumentPage docType="terms" pageTitle="Terms of Service" />;
}
